module.exports = __webpack_public_path__ + "img/shoot_00000.1ca10021.png";